import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./SideBar";
import Topbar from "./Topbar";
import { SIDEBAR_WIDTH } from "../constants";
import { useState } from "react";

import Walkthrough from "./Walkthrough";

function MainContainer({ hideHeader = false }: { hideHeader?: boolean }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSidebarToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <Walkthrough />
      {!hideHeader && <Topbar handleSidebarToggle={handleSidebarToggle} />}
      <Sidebar
        mobileOpen={mobileOpen}
        handleSidebarToggle={handleSidebarToggle}
      />
      <Box
        component="main"
        className="main_content"
        sx={{
          marginLeft: "auto",
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
        }}
      >
        <Container className="sub-layout">
          <Outlet />
        </Container>
      </Box>
    </>
  );
}
export default MainContainer;
